// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"63d1a816","239":"dc12fe8d","453":"91141d16","455":"a92c6827"}[chunkId] + ".chunk.js";
};